module.exports = __webpack_public_path__ + "static/media/freepik  Plant  inject 2@3x.c85122e4.png";